import { createApi } from '@reduxjs/toolkit/query/react';

import { StatusDto } from '../common/dto/common.dto';
import { OrganisationContactDto, OrganisationCustomizationUpdateDto, OrganisationSettingsUpdateDto, OrganisationViewDto } from '../common/dto/organisation.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CORE_SERVICE;
const TAG_TYPE = 'Organisation';

export const organisationApi = createApi({
  reducerPath: 'organisationApi',
  baseQuery: customFetchBase(`${API_URI}/api/organisation`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    getOrganisation: builder.query<OrganisationViewDto, void>({
      query: () => {
        return ``;
      },
    }),

    updateCustomization: builder.mutation<OrganisationViewDto, OrganisationCustomizationUpdateDto>({
      query(data) {
        return {
          url: 'customization',
          method: 'PUT',
          body: data,
        };
      },
    }),
    updateSettings: builder.mutation<OrganisationViewDto, OrganisationSettingsUpdateDto>({
      query(data) {
        return {
          url: 'settings',
          method: 'PUT',
          body: data,
        };
      },
    }),
    updateContact: builder.mutation<OrganisationViewDto, OrganisationContactDto>({
      query(data) {
        return {
          url: 'contact',
          method: 'PUT',
          body: data,
        };
      },
    }),
    logoutAllUsers: builder.query<StatusDto, void>({
      query: () => {
        return `logoutAllUsers`;
      },
    }),
  }),
});

// auto-generated based on the defined endpoints
export const {
  useGetOrganisationQuery,
  useLazyGetOrganisationQuery,
  useUpdateCustomizationMutation,
  useUpdateContactMutation,
  useUpdateSettingsMutation,
  useLazyLogoutAllUsersQuery,
} = organisationApi;
